import axios from 'axios'
import { getInfo, setInfo, removeInfo } from '@/utils/auth'
import { login } from '@/api/pmi/login'

const state = {
    infos: getInfo('infos'),
    tokens: getInfo('tokens'),
    ids: getInfo('IDS'),
    dataTheme: 'default',
    gray: false,
    setgradId: 1,
    tabstuat: 99,
    templates: [{
            id: 0,
            name: 'newsboard',
            imgNews: true,
            textNews: true,
            show: true
        },
        {
            id: 1,
            name: 'drill-column',
            show: true
        },
        {
            id: 2,
            name: 'advertisingboard',
            show: true
        },
        {
            id: 3,
            name: 'training',
            show: true
        },
        {
            id: 4,
            name: 'test-center',
            show: true
        },
        {
            id: 5,
            name: 'drillmaster',
            show: true
        },
        {
            id: 6,
            name: 'ranking-list',
            contribution: true,
            hot: true,
            show: true
        },
    ],
}

const mutations = {
    newsboard: (state, boolen) => {
        state.templates[0].show = boolen
    },
    drillcolumn: (state, boolen) => {
        state.templates[1].show = boolen
    },
    advertisingboard: (state, boolen) => {
        state.templates[2].show = boolen
    },
    training: (state, boolen) => {
        state.templates[3].show = boolen
    },
    testcenter: (state, boolen) => {
        state.templates[4].show = boolen
    },
    drillmaster: (state, boolen) => {
        state.templates[5].show = boolen
    },
    rankinglist: (state, boolen) => {
        state.templates[6].show = boolen
    },
    SET_INFOS: (state, infos) => {
        setInfo('infos', infos)
        // 注意这个地方。目前在考试模块是以JSON字符串的方式读取用户信息的。但在一些废弃的老代码那里是以对象的方式读取用户信息的。
        state.infos = JSON.stringify(infos)
    },
    SET_TOKENS: (state, tokens) => {
        setInfo('tokens', tokens)
        // debugger
        state.tokens = tokens
    },
    SET_IDS: (state, ids) => {
        setInfo('IDS', ids)
        state.ids = ids
    },
    setGrayNum(state, data) {
        state.setgradId = data
    },
    setDataTheme(state, data) {
        state.dataTheme = data
        setInfo('clond-college-dataTheme', data)
    },
    // setTemplates(state, data) {
    //     state.templates = data
    //     setInfo('clond-college-templates', data)
    // },
    setGray(state, data) {
        state.gray = data
            // console.log(data)
        setInfo('clond-college-gray', data)
    },
    SET_TABQIT: (state, data) => {
        state.tabstuat = data
    },


}

const actions = {
    Login({ commit }, userInfo) {
        const username = userInfo.name.trim()
        return new Promise((resolve, reject) => {
            login(username, userInfo.pass).then(response => {
                let setinfos = response.result       
                commit('SET_TOKENS', response.result.token)
                commit('SET_IDS', response.result.id)
                commit('SET_INFOS', setinfos)
                resolve(response)

            }).catch(error => {
                reject(error)
            })
        })
    },
    // get user info
    getInfo({ commit }, datainfo) {
        const url = datainfo.url
        return new Promise((resolve, reject) => {
            axios.get(url, { params: { token: state.tokens } }).then(response => {
                const { data } = response
                let setinfos = response.result
                commit('SET_INFOS', response.data.response)
                setInfo('infos', response.data.response)
                resolve(data)
            }).catch(error => {
                reject(error)
            })
        })
    },



    // remove user
    logout({ commit }) {
        return new Promise(resolve => {
            commit('SET_TOKENS', '')
            commit('SET_IDS', '')
            commit('SET_INFOS', '')
            removeInfo('clond-college-dataTheme')
            removeInfo('clond-college-gray')
            removeInfo('infos')
            removeInfo('IDS')
            removeInfo('tokens')
            removeInfo('storageObj')

            resolve()
        })
    },


    setDataTheme({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit('setDataTheme', data)
            resolve()
        })
    },
    setTemplates({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit('setTemplates', data)
            resolve()
        })
    },
    setGray({ commit }, data) {
        return new Promise((resolve, reject) => {
            commit('setGray', data)
            resolve()
        })
    },
}


export default {
    state,
    actions,
    mutations
}